import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material';
import { ShowDataInputComponent } from './show-data-input.component';


@NgModule({
  entryComponents: [
    ShowDataInputComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  declarations: [
    ShowDataInputComponent
  ],
  exports: [
    ShowDataInputComponent
  ]
})
export class ShowDataInputModule {}
